import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EsriExpand } from '../../../config/esri.module';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../core/service/user.service';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
    selector: 'print',
    templateUrl: './print.component.html',
    standalone: false
})
export class PrintComponent extends BaseWidget implements OnInit, AfterViewInit {
  @ViewChild('printComponentRef', { static: true }) printComponentRef: ElementRef;

  author: string;

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService,
    private _translate: TranslateService,
    private _userService: UserService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  ngOnInit() {
    // get MainMapService
    const mapView: any = this.mainMapService.mapView;

    // Create an Expand instance and set the content
    const expandProperties: __esri.ExpandProperties = {
      view: mapView,
      id: 'PrintComponent',
      content: this.printComponentRef.nativeElement,
      expandIcon: 'print',
      expanded: true,
    };
    this.expandWidget = new EsriExpand(expandProperties);
    // translate tooltip icon
    super.translateToolTipWidgetIcon(this.expandWidget, this._translate, 'WIDGET.PRINT.TOOLTIP');

    // get default username
    this.author = this._userService.user.userId;

    // add widget to the main map
    this.addWidgetToMainMap(mapView);
  }

  ngAfterViewInit() {
    // listen on language change
    this._translate.onLangChange.subscribe(() => {
      super.translateToolTipWidgetIcon(this.expandWidget, this._translate, 'WIDGET.PRINT.TOOLTIP');
    });
  }

  /**
   * @function setInitValues
   * @param id
   * @param expand
   * @description Sets the initial values
   */
  public setInitValues(id: string, expand: boolean) {
    super.setInitValues(id, expand);
    this.mainMapService.deactivateMapInteraction();
  }

  /**
   * @function destroySelf
   * @description First notify with componentDestroySubject that this component
   * will be destroyed. Destroy self and the widget reference from DOM and also from memory
   */
  public destroySelf() {
    super.destroySelf();
    this.mainMapService.activateMapInteraction();
  }

  /* private methodes */
  /**
   * adds the new widget to a given map
   * @param mapView the map to add the widget to
   */
  private addWidgetToMainMap(mapView: any) {
    mapView.ui.add(this.expandWidget, 'top-right');
    this.mainMapService.registerWidget(this.expandWidget);
  }
}
